var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteArr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 22,
    viewBox: "0 0 25 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.250193 11.2446C0.250193 11.6507 0.41152 12.0402 0.698685 12.3274C0.985849 12.6145 1.37533 12.7759 1.78144 12.7759H19.5225L12.9473 19.348C12.8049 19.4904 12.692 19.6594 12.615 19.8454C12.5379 20.0314 12.4983 20.2308 12.4983 20.4321C12.4983 20.6335 12.5379 20.8328 12.615 21.0188C12.692 21.2049 12.8049 21.3739 12.9473 21.5162C13.0897 21.6586 13.2587 21.7715 13.4447 21.8486C13.6307 21.9256 13.8301 21.9653 14.0314 21.9653C14.2328 21.9653 14.4322 21.9256 14.6182 21.8486C14.8042 21.7715 14.9732 21.6586 15.1156 21.5162L24.3031 12.3287C24.4457 12.1865 24.5588 12.0175 24.636 11.8315C24.7132 11.6455 24.7529 11.446 24.7529 11.2446C24.7529 11.0432 24.7132 10.8438 24.636 10.6577C24.5588 10.4717 24.4457 10.3027 24.3031 10.1605L15.1156 0.972985C14.828 0.685458 14.4381 0.523926 14.0314 0.523926C13.6248 0.523926 13.2348 0.685458 12.9473 0.972985C12.6598 1.26051 12.4983 1.65048 12.4983 2.05711C12.4983 2.46374 12.6598 2.85371 12.9473 3.14124L19.5225 9.71336H1.78144C1.37533 9.71336 0.985849 9.87469 0.698685 10.1619C0.41152 10.449 0.250193 10.8385 0.250193 11.2446Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteArr);
export default __webpack_public_path__ + "static/media/white-arr.e9980dc0185a4e14ed964d3bac573afb.svg";
export { ForwardRef as ReactComponent };